import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2421b596"
import script from "./index.vue?vue&type=script&route=%2Faccount%2Fmanagement&lang=js"
export * from "./index.vue?vue&type=script&route=%2Faccount%2Fmanagement&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports